import { render, staticRenderFns } from "./serviceProvideRemarkView.vue?vue&type=template&id=07dc115d"
import script from "./serviceProvideRemarkView.vue?vue&type=script&lang=js"
export * from "./serviceProvideRemarkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports